<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [title]="'Select Booking Test'"
      [class]="extraClass"
      [canGoBack]="true"/>
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>

    <tidy-card>
      <tidy-row>
        <tidy-text [header]="'Select Booking Test'" />
      </tidy-row>
      <tidy-row>
        <tidy-text [body]="'Choose which residential booking variant to test:'" />
      </tidy-row>
    </tidy-card>

    @for (option of testOptions; track option.variant) {
      <tidy-card-button (action)="selectVariant(option)">
        <tidy-row>
          <tidy-text [body]="option.label" />
        </tidy-row>
      </tidy-card-button>
    }

  </tidy-wrapper>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
